module.exports = __webpack_public_path__ + "static/media/art-gallery-55.2bfe3614.jpg";